import { Flex } from "@chakra-ui/react";

import { MonitoringTube } from "@nens/brostar/openapi-client";
import { tubeStatusOptions } from "@nens/brostar/uploadapi-client";
import { ColumnDefinition } from "@nens/chakra/components";

import { SearchOption } from "@/components/searchbox";
import { TableOverview } from "@/components/table-overview";
import { renderDefault, renderEnum } from "@/helpers/table-render-functions";
import { useGmwMonitoringtubesAllPagesQuery } from "@/queries/query-gmw-monitoringtubes";

import { useGmwContext } from "../../contexts/gmw-context";

const monitoringTubeInformation: SearchOption<keyof MonitoringTube, keyof MonitoringTube>[] = [
  { key: "tubeNumber", label: "Buis nummer" },
  {
    key: "tubeStatus",
    label: "Buis status",
    enum: tubeStatusOptions.map(({ value, label }) => ({ key: value, label })),
  },
  { key: "gmwBroId", label: "GMW" },
];

const columnDefinitions: ColumnDefinition<MonitoringTube>[] = monitoringTubeInformation.map(
  ({ enum: enumValue, key, label }) => ({
    title: label,
    renderFunction: (row) => {
      const value = row[key];
      if (enumValue && typeof value === "string") return renderEnum(value, enumValue);
      return renderDefault(value);
    },
    width: "1fr",
  })
);

const MonitoringTubeTable: React.FC = () => {
  const { selectedGmw } = useGmwContext();
  const gmwMonitoringtubesQuery = useGmwMonitoringtubesAllPagesQuery({
    gmwBroId: selectedGmw?.broId,
  });

  return (
    <Flex flexDir="column" position="relative" w="50%">
      <TableOverview
        paginationProps={undefined}
        columnDefinitions={columnDefinitions}
        isLoading={gmwMonitoringtubesQuery.isLoading}
        emptyText={selectedGmw ? "Geen monitoringsbuizen beschikbaar" : "Geen GMW geselecteerd"}
        tableData={gmwMonitoringtubesQuery.data?.results ?? []}
      />
    </Flex>
  );
};

export { MonitoringTubeTable };
